import { Component, OnInit } from '@angular/core';
import { RestService } from '../../../service/rest.service';

@Component({
  selector: 'app-admin-footer',
  templateUrl: './admin-footer.component.html',
  styleUrls: ['./admin-footer.component.scss']
})
export class AdminFooterComponent implements OnInit {

  currentDate: Date = new Date();
  version: string;

  constructor(private restService: RestService) { }

  ngOnInit() {
    this.restService.getVersion()
      .subscribe( (d: any) => {
        this.version = d && d.message ?  d.message : '';
      });
  }

}
